<template>
    <site-img
        v-if="testimonials.length"
        class="md-testimonial broker-slider-color"
        type="bgImg"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{ 'background-color': bgType == 'color' ? bgColor : null }"
        dir="width"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
        >
            <div class="title-wrap">
                <div :style="{ visibility: title ? 'unset' : 'hidden' }" v-html="formatFontSize(title, '--mg-title-size')" class="mg-title"></div>
                <Arrows
                    :show="showArrow"
                    :disabled="disabled"
                    @prev="prev"
                    @next="next"
                />
            </div>
            <Slider
                ref="sliders"
                @disabled="updateDisabled"
                @showarrow="updateShowArrow"
                theme="broker-slider-color"
                :config="config"
                :list="testimonials"
                :pcHeight="313"
                :mobileHeight="313"
                :itemPcWidth="371"
                :itemMobileWidth="371"
            >
                <template #default="{ item, index }">
                    <!-- slide-item -->
                    <div
                        class="item slider-inner-item"
                        @click="()=>toViewMore(item)"
                        :style="{
                            backgroundColor: colors[index % 3]
                        }"
                        @mouseenter="
                            $el.querySelectorAll('.slider-inner-item')[
                                index
                            ].style.borderColor = colors[index % 3]
                        "
                        @mouseleave="
                            $el.querySelectorAll('.slider-inner-item')[
                                index
                            ].style.borderColor = '#dadada'
                        "
                    >
                        <img v-if="item.rmaTrackPixelUrl" class="rma-pixel-img" :src="item.rmaTrackPixelUrl" loading="lazy" alt="" />
                        <div
                            class="top"
                            :style="{
                                borderColor: colors[index % 3]
                            }"
                        >
                            <i class="iconfont icon-quotationmarks"></i>
                            <div class="desc" v-html="item.reviewContent"></div>
                            <div class="date">
                                <only-client>{{ $ft.formatDate(item.reviewTime, 'MMM dd yyyy') }}</only-client>
                            </div>
                            <ReviewScore
                                :sourceType="item.sourceType"
                                :score="item.reviewRate"
                                :iconSize="14"
                            />
                        </div>
                        <div class="agent-info">
                            <site-img
                                v-if="item.avatarLink"
                                class="avatar"
                                :src="item.avatarLink"
                                dir="height"
                            />
                            <div class="agent-name">
                                <p v-html="item.reviewerName"></p>
                            </div>
                            <ReviewSourceLogo :sourceType="item.sourceType" />
                        </div>
                    </div>
                </template>
            </Slider>
        </module-box>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </site-img>
</template>

<script>
import common from '../index';
import Slider from '../_components/slider.vue';
import Arrows from '../_components/arrows.vue';
export default {
    mixins: [common],
    components: { Slider, Arrows },
    data: function() {
        return {
            colors: ['#23c864', '#ff973b', '#45adff'],
            disabled: { prev: false, next: false },
            showArrow: false
        };
    },
    computed: {
        config({ autoPlay, delayTime, speed }) {
            return {
                autoPlay: autoPlay,
                interval: delayTime,
                speed
            };
        }
    },
    methods: {
        prev() {
            this.$refs.sliders.prev();
        },
        next() {
            this.$refs.sliders.next();
        },
        updateDisabled(disabled) {
            this.disabled = disabled;
        },
        updateShowArrow(show) {
            this.showArrow = show;
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-testimonial.broker-slider-color {
    .rma-pixel-img{
      display: block;
        width: 0;
        height: 0;
    }
    .mg-container {
        width: calc(100% - 200px);
        @include media-1680 {
            width: 1180px !important;
        }
    }
    .title-wrap {
        display: flex;
        flex-direction: row;
        padding-bottom: 25px;
        justify-content: space-between;
        position: relative;
        @include media-600 {
            padding-bottom: 10px;
            // .mg-title {
            //     font-size: 16px;
            //     margin-bottom: 0;
            // }
        }
        .mg-title {
            padding-bottom: 0;
            margin: 0;
        }
        &.no-under-line {
            &::after {
                display: none;
            }
        }
        h2 {
            font-family: var(--mg-title-font);
            font-size: var(--mg-title-size);
            color: var(--mg-title-color);
            text-align: var(--mg-title-align);
            line-height: var(--mg-title-line-height);
            letter-spacing: var(--mg-title-letter-spacing);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 20px;
            flex: 1;
            p {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            @include media-600 {
                font-size: var(--mg-title-size-mobile) !important;
                line-height: var(--mg-title-line-height-mobile) !important;
                letter-spacing: var(--mg-title-letter-spacing-mobile);
            }
        }
    }
    .slide-item {
        .item {
            width: 100%;
            height: 100%;
            background: #fff;
            border: 1px solid #dadada;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            cursor: pointer;
            &:hover {
                box-shadow: 0 4px 20px 0 rgba(0, 10, 30, 0.1);
            }
        }
        .top {
            padding: 20px;
            position: relative;
            &::after {
                content: '';
                width: 0;
                height: 8px;
                border: 8px solid transparent;
                border-top-color: inherit;
                border-top-width: 8px;
                border-top-style: solid;
                position: absolute;
                left: 36px;
                bottom: -29px;
            }
            .icon-quotationmarks {
                position: absolute;
                left: 20px;
                top: 6px;
                color: rgba(218, 218, 218, 0.3);
                font-size: 30px;
                z-index: 1;
            }
        }
        .desc {
            height: 114px;
            margin-bottom: 18px;
            @include webkitBox(6);
            font-size: 14px;
            color: #fff;
            line-height: 19px;
        }
        .review-star {
            .icon-star-fill {
                &.active {
                    color: #fff;
                }
            }
        }
        .date {
            text-align: right;
            color: #fff;
            font-size: 12px;
            margin-bottom: 10px;
        }
        .agent-info {
            padding: 20px;
            height: 92px;
            background: #fff;
            border-radius: 0 0 5px 5px;
            display: flex;
            align-items: center;
            margin-top: 5px;
            .avatar {
                width: 50px;
                height: 50px;
                margin-right: 10px;
                border-radius: 50%;
                object-fit: cover;
            }
            .agent-name {
                flex: 1;
                margin-right: 20px;
                font: 16px var(--font-bold);
                color: #191919;
            }
            .source-logo-container {
                max-height: 50px;
                max-width: 180px;
            }
        }
    }
}
</style>
